module.exports = require("@babel/runtime-corejs2/core-js/array/from");